import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Avatar from '../Avatar';
import GroupIcon from './GroupIcon';

const GroupAvatar = ({ src, initials, alt, size }) => {
  const iconSize = useMemo(() => {
    switch (size) {
      case '8':
        return '4';
      case '32':
        return '20';
      default:
        // when size === 12
        return '6';
    }
  }, [size]);

  return (
    <Avatar
      src={!initials && (src || <GroupIcon size={iconSize} />)}
      initials={initials}
      alt={alt}
      size={size}
      className="mx-auto"
      isBlock
    />
  );
};

GroupAvatar.propTypes = {
  src: PropTypes.string,
  initials: PropTypes.string,
  size: PropTypes.string,
  alt: PropTypes.string,
};

GroupAvatar.defaultProps = {
  src: null,
  initials: null,
  size: '12',
  alt: null,
};

export default GroupAvatar;
